import type { AppSearchStandard } from "@shared/models/analytics/app"
import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { PreparedAction } from "../../action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "../create-narrative"
import createNarrative from "../create-narrative"

interface Payload {
  jurisdictionId: string
  jurisdictionTitle: string
  jurisdictionType: "state" | "organization" | "school"
}

export default function standardsSearchSelectJurisdictionAction(payload: Payload): PreparedAction {
  return {
    name: "STANDARDS_SEARCH_SELECT_JURISDICTION",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, _findFn: FindFn, _userId: string): Narrative {
  let newEvent: AppSearchStandard = {
    ...createBlankEvent(),
    root_id: null,
    root_type: "app",
    date_plan_scheduled_for: null,

    primary_verb: "use",
    primary_possessive: "owns",

    primary_object_type: "app",
    primary_object_id: "commoncurriculum.com",
    primary_object_specifier: "standards_search",
    primary_object_id_and_ancestor_ids: ["commoncurriculum.com"],

    adverbial_verb: "selecting",

    adverbial_object_type: "jurisdiction",
    adverbial_object_id: payload.jurisdictionId,
    adverbial_object_specifier: null,
    adverbial_object_id_and_ancestor_ids: ["commoncurriculum.com"],
  }
  return createNarrative({
    titleForAnalytics: "Standards Search - Select Jurisdiction",
    description: `Selected ${payload.jurisdictionType}, titled ${payload.jurisdictionTitle}`,
    newAnalyticsEvents: [newEvent],
  })
}
